import API from '../../apiCreate'
import { getParams } from '../../getParams'
import type {
  ResponseVkAdsAccounts,
  ResponseVkAdsForms,
  ResponseVkAdsSelection,
  ResponseVkAdsSync,
  VkAdsSelectionBody,
} from './vk-ads.types'

export const vkAdsApi = {
  /** GET /v1/vk-ads/accounts?id={endpointId} */
  accounts: (endpointId: number) =>
    API.get<ResponseVkAdsAccounts>(
      `vk-ads/accounts${getParams({ id: endpointId })}`,
    ),

  /** GET /v1/vk-ads/forms?id={endpointId} */
  forms: (endpointId: number) =>
    API.get<ResponseVkAdsForms>(`vk-ads/forms${getParams({ id: endpointId })}`),

  /** PUT /v1/vk-ads/selection?id={endpointId} */
  selection: (endpointId: number, data: VkAdsSelectionBody) =>
    API.put<ResponseVkAdsSelection>(
      `vk-ads/selection${getParams({ id: endpointId })}`,
      data,
    ),

  /** POST /v1/vk-ads/sync?id={endpointId} */
  sync: (endpointId: number) =>
    API.post<ResponseVkAdsSync>(`vk-ads/sync${getParams({ id: endpointId })}`),
}
